export default function posts(state = {}) {
  return {
    isLoading: false,
    isShowLoadMore: true,
    currentPage: state.currentPage || 1,
    nextPage: state.nextPage || 2,
    lastPage: state.lastPage || 1,
    url: state.url || null,
    firstPageUrl: state.firstPageUrl || null,
    lastPageUrl: state.lastPageUrl || null,

    get isOnFirstPage() {
      return this.currentPage === 1
    },
    get hasMorePages() {
      return this.currentPage < this.lastPage
    },
    get previousPageUrl() {
      return !this.isOnFirstPage ? `${this.url}?page=${this.currentPage - 1}` : '#'
    },
    get nextPageUrl() {
      return this.hasMorePages ? `${this.url}?page=${this.currentPage + 1}` : '#'
    },

    async onLoadMore() {
      if (this.nextPage > this.lastPage) return

      this.isLoading = true

      try {
        const html = await fetchPosts(this.url, this.nextPage)
        
        this.$refs.list.insertAdjacentHTML('beforeend', html)

        this.currentPage += 1
        this.nextPage += 1

        if (this.currentPage >= this.lastPage) {
          this.isShowLoadMore = false
        }
      } catch (e) {
        console.error('Load more failed', e)
      } finally {
        this.isLoading = false
      }
    }
  }
}

async function fetchPosts(url, page) {
  const response = await axios.get(url, {
    params: { page },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })

  return response.data.html
}
